<template>
  <van-sticky :container="container" class="QzSearch">
    <van-search
      v-if="likeSearch"
      v-model="search.searchValue"
      show-action
      placeholder="请输入课程名称或录入人"
      shape="round"
      :clearable="false"
      @input="onInputEvent"
    >
      <template #action>
        <div class="findMore" @click="openShaiXuan">
          <iconpark-icon
            class="svg-icon"
            name="shaixuan"
            @click="close"
          ></iconpark-icon
          >筛选
        </div>
      </template>
    </van-search>
    <div v-if="searchProps[0]" class="QzSearch-miniSearch">
      <div class="miniSearch-list" @click.stop="openKjPicker(0)">
        {{ label[searchProps[0].prop] }}
        <van-icon name="arrow-down"></van-icon>
      </div>
      <div
        v-if="searchProps[1]"
        class="miniSearch-list"
        @click.stop="openKjPicker(1)"
      >
        {{ label[searchProps[1].prop] }}
        <van-icon name="arrow-down"></van-icon>
      </div>
    </div>
    <van-popup
      class="qzShaiXuan"
      v-model="showShaiXuan"
      round
      position="bottom"
    >
      <div class="qzShaiXuan-header">
        筛选
        <iconpark-icon
          class="svg-icon"
          name="guanbi2x"
          @click="close"
        ></iconpark-icon>
      </div>
      <qz-split text="请选择筛选条件" />
      <van-cell-group>
        <van-field
          v-for="(item, index) in listData"
          :key="index"
          v-model="labelValue[item.prop]"
          :label="item.label"
          :right-icon="item.type === 'select' ? 'arrow' : ''"
          :placeholder="item.type === 'select' ? '请选择' : '请输入'"
          :required="item.required"
          :readonly="item.type === 'select'"
          input-align="right"
          @click="openPicker(index, item.type !== 'select')"
          @input="val => onInput(val, item)"
        />
      </van-cell-group>
      <div class="qzShaiXuan-button">
        <van-button type="default" round @click="reset">重置</van-button>
        <van-button type="primary" round @click="getData">搜索</van-button>
      </div>
    </van-popup>
    <van-popup class="qzPicker" v-model="showKjPicker" round position="bottom">
      <van-picker
        show-toolbar
        :title="pickerData.title"
        :columns="pickerData.columns"
        @cancel="showKjPicker = false"
        @confirm="onKjConfirm"
        :default-index="pickerData.defaultIndex"
      />
    </van-popup>
    <van-popup class="qzPicker" v-model="showPicker" round position="bottom">
      <van-picker
        show-toolbar
        :title="pickerData.title"
        :columns="pickerData.columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
        :default-index="pickerData.defaultIndex"
      />
    </van-popup>
  </van-sticky>
</template>

<script>
export default {
  name: "QzSearch",
  props: {
    likeSearch: {
      type: Boolean,
      default: true
    },
    searchProps: {
      type: Array,
      default: () => []
    },
    label: {
      type: Object,
      default: () => {}
    },
    search: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      labelValue: {},
      searchValue: {},
      container: null,
      showShaiXuan: false,
      showKjPicker: false,
      showPicker: false,
      pickerData: {},
      listData: []
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.container = $(this.$parent.$el).find(".QzList");
    });
  },
  methods: {
    onInputEvent() {
      this.$parent.query();
    },
    close() {
      this.pickerData = {};
      this.showShaiXuan = false;
    },
    openShaiXuan() {
      this.reset();
      this.showShaiXuan = true;
    },
    reset() {
      this.labelValue = Object.assign({}, this.label);
      this.searchValue = Object.assign({}, this.search);
      this.listData = JSON.parse(JSON.stringify(this.searchProps));
      this.$forceUpdate();
    },
    getData() {
      this.showShaiXuan = false;
      this.onSearch();
    },
    openKjPicker(index) {
      this.showKjPicker = true;
      this.pickerData = {
        title: this.searchProps[index].label,
        columns: this.searchProps[index].options.columns,
        prop: this.searchProps[index].prop,
        index: index,
        defaultIndex: this.searchProps[index].options.defaultIndex
      };
    },
    onKjConfirm(value, index) {
      this.showKjPicker = false;
      this.label[this.pickerData.prop] = value.text;
      this.search[this.pickerData.prop] = value.value;
      this.searchProps[this.pickerData.index].options.defaultIndex = index;
      this.$parent.query();
    },
    openPicker(index, flag) {
      if (flag) {
        return;
      }
      this.showPicker = true;
      this.pickerData = {
        title: this.listData[index].label,
        columns: this.listData[index].options.columns,
        prop: this.listData[index].prop,
        index: index,
        defaultIndex: this.listData[index].options.defaultIndex
      };
    },
    onConfirm(value, index) {
      this.showPicker = false;
      this.labelValue[this.pickerData.prop] = value.text;
      this.searchValue[this.pickerData.prop] = value.value;
      this.listData[this.pickerData.index].options.defaultIndex = index;
    },
    onInput(val, item) {
      if (item.type !== "input") {
        return;
      }
      this.searchValue[item.prop] = val;
    },
    onSearch() {
      this.$emit(
        "getSearchValue",
        this.searchValue,
        this.labelValue,
        this.listData
      );
    }
  }
};
</script>

<style lang="less" scoped>
.QzSearch {
  .findMore {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 88px;
    height: 34px;
    border: 1px solid #e5e5e5;
    border-radius: 16px;
    font-family: SourceHanSansCN-Regular;
    font-size: 14px;
    color: #333333;
    letter-spacing: 0;
    font-weight: 400;
    .svg-icon {
      margin-right: 8px;
    }
  }
  /deep/.van-field__left-icon .van-icon {
    font-size: 16px;
  }
  /deep/input.van-field__control::placeholder {
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #b2b2b2;
    letter-spacing: 0;
    font-weight: 400;
  }
  .QzSearch-miniSearch {
    display: flex;
    align-items: center;
    height: 40px;
    background-color: #F2F2F4;
    .miniSearch-list {
      padding: 0 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex: 1;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #333333;
      letter-spacing: 0;
      font-weight: 400;
      .van-icon {
        color: #b2b2b2;
      }
    }
  }
  .qzShaiXuan {
    background-color: #f2f2f4;
    .qzShaiXuan-header {
      background-color: #fff;
      height: 44px;
      line-height: 44px;
      border-radius: 8px 8px 0px 0px;
      text-align: center;
      .svg-icon {
        position: absolute;
        top: 16px;
        right: 16px;
        font-size: 12px;
      }
    }
    .van-cell::after {
      right: 0;
    }
    .qzShaiXuan-button {
      position: relative;
      display: flex;
      background-color: #fff;
      padding: 40px 15px 10px;
      &::before {
        position: absolute;
        box-sizing: border-box;
        content: " ";
        pointer-events: none;
        right: 0;
        top: 0;
        left: 16px;
        border-top: 1px solid #e5e5e5;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
      }
      .van-button {
        flex: 1;
        height: 50px;
        & + .van-button {
          margin-left: 15px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/QzSearch/index.vue